import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mask--sprite",
  "use": "mask--sprite-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mask--sprite\">\n<circle cx=\"50\" cy=\"50\" r=\"50\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol